var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c(
      "div",
      {
        staticClass: "toast qg-consent qg-consent-initial consent-toast hidden",
        attrs: {
          role: "alert",
          "aria-live": "assertive",
          "aria-atomic": "true",
          "data-autohide": "false",
          "data-animation": "false",
        },
      },
      [
        _c("div", { staticClass: "toast-header bg-info text-white" }, [
          _c("strong", { staticClass: "mr-auto" }, [
            _vm._v(_vm._s(_vm.textTitle)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "toast-body p-10 text-left" }, [
          _c("p", [
            _vm._v(
              "\n                " + _vm._s(_vm.textLineA) + "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("p", {
            staticClass: "d-inline",
            domProps: { innerHTML: _vm._s(_vm.textLineB) },
          }),
          _vm._v(" "),
          _c("p", {
            staticClass: "d-block",
            domProps: { innerHTML: _vm._s(_vm.textLineC) },
          }),
          _vm._v(" "),
          _c("p", { staticClass: "no-margin text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-lg qg-consent-no",
                attrs: { "data-dismiss": "toast" },
                on: { click: _vm.consentNoClick },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.textNoBtn) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-lg qg-consent-ok",
                attrs: { "data-dismiss": "toast" },
                on: { click: _vm.giveConsent },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.textYesBtn) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
        ]),
      ]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "toast qg-consent qg-consent-dismiss hidden",
        attrs: {
          role: "alert",
          "aria-live": "assertive",
          "aria-atomic": "true",
          "data-autohide": "false",
          "data-animation": "false",
        },
      },
      [
        _c("div", { staticClass: "toast-header bg-info text-white" }, [
          _c("strong", { staticClass: "mr-auto" }, [
            _vm._v(_vm._s(_vm.textTitle)),
          ]),
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "toast-body p-10 text-left" }, [
          _c("p", [
            _vm._v(
              "\n                " +
                _vm._s(_vm.textLineReject) +
                "\n            "
            ),
          ]),
          _vm._v(" "),
          _c("p", { staticClass: "no-margin text-right" }, [
            _c(
              "button",
              {
                staticClass: "btn btn-info btn-lg qg-consent-back",
                attrs: { "data-dismiss": "toast" },
                on: { click: _vm.consentBackClick },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.textBackBtn) +
                    "\n                "
                ),
              ]
            ),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass:
                  "btn btn-info btn-lg qg-consent-no qg-consent-reject",
                attrs: { "data-dismiss": "toast" },
                on: { click: _vm.consentRejectClick },
              },
              [
                _vm._v(
                  "\n                    " +
                    _vm._s(_vm.textAcceptBtn) +
                    "\n                "
                ),
              ]
            ),
          ]),
          _vm._v(" "),
          _c("div", { staticClass: "clearfix" }),
        ]),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }